import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Routes } from "../../utils/constants";
import {
  getSurveyCollectors,
  getSurveyId,
  postSurveyAndRegisterSessionAndUpdateUser,
  upsertAccountAndSyncSF
} from "../../utils/helpers/api";
import { useGlobalState } from "../../contexts/GlobalContext";
import { useNotificationTimestamp } from "../../hooks/features/notification/useNotificationTimestamp";
import HomePlace from "../Mypage/UserSetting/HomePlace";
import BasicInterests from "../Mypage/UserSetting/BasicInterests";
import BasicInfo from "../Mypage/UserSetting/BasicInfo";
import WorkPlace from "../Mypage/UserSetting/WorkPlace";
import NewsletterSetting from "../Mypage/UserSetting/NewsletterSetting";
import {
  businessAndManagementJobs,
  creativeAndDesignJobs,
  environmentAndInfrastructureJobs,
  generalOrganizationAndSkillsKnowledge,
  generalSocialTrendsCode,
  generalWorkAndLifePlanning,
  informationAndTechnologyJobs1,
  informationAndTechnologyJobs2,
  occupationSelect,
  other,
  PERSON_TITLE,
  positions,
  workAddressSelect,
  environmentalManagementJobs,
  carbonNeutralJobs,
  solarPowerJobs,
  energyBusinessJobs,
  energySavingEquipmentJobs,
  circularEconomyJobs,
  chemicalAndPollutionJobs,
  otherEnvironmentalJobs,
} from "../../utils/constants/constant";
import { getLabelsFromIds } from "../../utils/helpers/string";

interface IStateLocation {
  data: IUserMetaDataApi;
  answerData: {
    ip_address?: string;
    pages?: IAnswerPage[];
  };
  agreeTerms?: boolean;
  agreements?: boolean;
  questionData: ISurveyDetail;
  title?: string;
}

const ConfirmAnswer: React.FC = () => {
  const location = useLocation();
  const { data, answerData, agreeTerms, agreements, questionData, title } =
    (location.state as IStateLocation) ?? {};
  const navigate = useNavigate();
  const [survey_id, set_survey_id] = useState<string | null>(null);
  const { survey_web_url_id } = useParams();
  const { setStateValue, globalState, setGlobalState, refreshAccessToken } = useGlobalState();
  const { addTimestamp } = useNotificationTimestamp();
  const { user } = globalState;
  const user_id = user?.user_id;

  const [state, setState] = useState<ISettingConfirmState>({
    accountSF: {},
    dataSyncCustomeSf: {},
  });

  const { accountSF, dataSyncCustomeSf } = state;

  useEffect(() => {
    if (survey_web_url_id) {
      handleFetchSurveyId();
    }
  }, [survey_web_url_id]);

  useEffect(() => {
    document.title = `【入力画面】 参加お申込みフォーム ${title}`;
  }, [title]);

  useEffect(() => {
    const metaTags = [
      {
        name: "keywords",
        content:
          "宣伝,広告,コピーライター,教育講座,SP,プロモーション,販売促進,クリエイティブ,クリエーティブ,デザイン,広報,PR,IR,編集,ライティング,環境,哲学,宣伝会議,販促会議,ブレーン,編集会議,PRIR,環境会議,人間会議,コピーライター養成講座,編集ライター養成講座,アドバタイムズ。",
      },
      {
        name: "description",
        content:
          "宣伝会議のwebサイト。広告宣伝・販促SP・広報PR・編集・広告クリエイティブなどの、出版事業と教育事業を展開しています。",
      },
    ];

    metaTags.forEach(({ name, content }) => {
      let tag = document.querySelector(
        `meta[name="${name}"]`
      ) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);

  const SDKG_InterestingThemes = [
    ...generalSocialTrendsCode,
    ...generalOrganizationAndSkillsKnowledge,
    ...generalWorkAndLifePlanning,
  ];
  SDKG_InterestingThemes.push({ label: "当てはまるものはない", value: "0" });

  const SDKG_EnvironmentalThemes = [
    ...environmentalManagementJobs,
    ...carbonNeutralJobs,
    ...solarPowerJobs,
    ...energyBusinessJobs,
    ...energySavingEquipmentJobs,
    ...circularEconomyJobs,
    ...chemicalAndPollutionJobs,
    ...otherEnvironmentalJobs,
  ]

  const SDKG_NewDepartment = [
    ...businessAndManagementJobs,
    ...creativeAndDesignJobs,
    ...environmentAndInfrastructureJobs,
    ...informationAndTechnologyJobs1,
    ...informationAndTechnologyJobs2,
    ...other,
  ];

  const SDKG_JobChangeInformation = [
    { label: "ある", value: "0" },
    { label: "なし", value: "1" },
  ];

  useEffect(() => {
    if (data) {
      const getLabelFromValue = (value: string) => {
        const found = PERSON_TITLE.find((item) =>
          item?.values?.includes(value)
        );
        return found ? found.label : null;
      };

      setState((prevState) => ({
        ...prevState,
        accountSF: {
          SsoID__pc: user?.user_metadata.customUserId, // customer id
          LastName: data.profile?.fullName?.lastName, // profile.fullname.lastname
          FirstName: data.profile?.fullName?.firstName, // profile.fullname.FirstName
          Company__pc: data.workPlaceInfo?.companyName, // workplace.companyname
          PersonEmail: user?.email,
          SDKG_NewJobLayer__pc:
            positions.find(
              (item) =>
                item.value == data?.workPlaceInfo?.positionCode?.toString()
            )?.label ?? "",
          ContactInformation__pc:
            data.profile?.contactType === 1 ? "自宅" : "勤務先",
          NameKana__pc: `${data?.profile?.fullNameKana?.lastName} ${data?.profile?.fullNameKana?.firstName}`, //profile.fullnameKana.FirstName + profile.fullnameKana.last name
          lbc_office_id__pc: data.workPlaceInfo?.lbcCode ?? "", // lbccode
          DepartmentName__pc: data.workPlaceInfo?.departmentName ?? "", // workplace.DepartmentName
          AddressType__pc: data.profile?.contactType === 1 ? "自宅" : "勤務先", // profile.contactType
          PersonMailingPostalCode:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.postalCode?.toString()
              : data.profile?.address?.postalCode?.toString(), // profile.address.PostalCode
          PersonMailingState:
            data.profile?.contactType !== 1
              ? workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.workPlaceInfo?.prefectureCode?.toString()
                )?.label ?? ""
              : workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.profile?.address?.prefectureCode?.toString()
                )?.label ?? " ", // profile.address.prefectureCode
          PersonMailingCity:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.city
              : data.profile?.address?.city, // profile.address.City
          PersonMailingStreet:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.line
              : data.profile?.address?.line ?? "", // profile.address.line
          CompanyTel__pc: data.workPlaceInfo?.phoneNumber ?? "", // workplace.phonenumber
          CompanyMobilePhone__pc: data.workPlaceInfo?.mobilePhoneNumber ?? "", // workplace.mobilePhoneNumber
          PersonHomePhone: data.profile?.phoneNumber ?? "", // workplace.phonenumber
          CompanyFax__pc: data.workPlaceInfo?.faxNumber ?? "", // workplace.CompanyFax
          Sex__pc: data.profile?.genderCode?.toString() ?? "0", // profile.genderCode
          TransitionSource__pc: user?.user_metadata.transition_source ?? "", // transition_source
          JobLayer__pc:
            getLabelFromValue(data.workPlaceInfo?.positionCode ?? "") ?? "", // workPlaceInfo.positionCode
          Newsletter1__pc: data.newsletterSubscription?.editorialBooks ?? false, // newsletterSubscription.editorialBooks
          Newsletter3__pc: data.newsletterSubscription?.editorialBrain ?? false, // newsletterSubscription.editorialBrain
          Newsletter5__pc:
            data.newsletterSubscription?.editorialHansokukaigi ?? false, // newsletterSubscription.editorialHansokukaigi
          Newsletter6__pc: data.newsletterSubscription?.advertimes ?? false, // newsletterSubscription.advertimes
          Newsletter7__pc:
            data.newsletterSubscription?.editorialKohokaigi ?? false, // newsletterSubscription.editorialKohokaigi
          Newsletter8__pc: data.newsletterSubscription?.contestsAwards ?? false, // newsletterSubscription.contestsAwards
          Newsletter9__pc:
            data.newsletterSubscription?.editorialSendenkaigi ?? false, // newsletterSubscription.editorialSendenkaigi
          Newsletter24__pc: data.newsletterSubscription?.classInfo ?? false, // newsletterSubscription.classInfo
          Newsletter11__pc:
            data.newsletterSubscription?.digitalMagazine ?? false, // newsletterSubscription.digitalMagazine
          Newsletter25__pc:
            data.newsletterSubscription?.adPlacementSponsorship ?? false, // newsletterSubscription.adPlacementSponsorship
          Newsletter18__pc:
            data.newsletterSubscription?.environmentalBusinessOnline ?? false, // newsletterSubscription.environmentalBusinessOnline
          Newsletter21__pc:
            data.newsletterSubscription?.environmentalBusinessOnlineNews ?? false,
          Newsletter10__pc:
            data.newsletterSubscription?.sendenkaigiInfo ?? false, // newsletterSubscription.sendenkaigiInfo
          Newsletter26__pc:
            data.newsletterSubscription?.jobChangeInfo ?? false, // newsletterSubscription.jobChangeInfo
        },
        dataSyncCustomeSf: {
          SsoID__c: user?.user_metadata.customUserId.toString(),
          LastName: data.profile?.fullName?.lastName,
          FirstName: data.profile?.fullName?.firstName,
          NameKana__pc: `${data?.profile?.fullNameKana?.lastName} ${data?.profile?.fullNameKana?.firstName}`,
          Company__pc: data.workPlaceInfo?.companyName,
          PersonDepartment: data.workPlaceInfo?.departmentName,
          SDKG_NewJobLayer__pc:
            positions.find(
              (item) =>
                item.value == data?.workPlaceInfo?.positionCode?.toString()
            )?.label ?? "",
          ContactInformation__pc:
            data.profile?.contactType !== 1 ? "勤務先" : "自宅",
          SDKG_PriorityContacts__pc:
            data.profile?.contactType !== 1 ? "勤務先" : "自宅",
          AddressType__pc: data.profile?.contactType === 1 ? "自宅" : "勤務先",
          PersonMailingPostalCode:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.postalCode?.toString()
              : data.profile?.address?.postalCode?.toString(),
          PersonMailingState:
            data.profile?.contactType !== 1
              ? workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.workPlaceInfo?.prefectureCode?.toString()
                )?.label ?? ""
              : workAddressSelect.find(
                  (item) =>
                    item.value ===
                    data?.profile?.address?.prefectureCode?.toString()
                )?.label ?? "",
          PersonMailingCity:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.city
              : data.profile?.address?.city,
          PersonMailingStreet:
            data.profile?.contactType !== 1
              ? data.workPlaceInfo?.line
              : data.profile?.address?.line ?? "",
          CompanyTel__pc: data.workPlaceInfo?.phoneNumber ?? "",
          CompanyMobilePhone__pc: data.workPlaceInfo?.mobilePhoneNumber ?? "",
          PersonHomePhone: data.profile?.phoneNumber ?? "",
          PersonMobilePhone: data.profile?.mobilePhoneNumber ?? "",
          CompanyFax__pc: data.workPlaceInfo?.faxNumber ?? "",
          PersonEmail: user?.email,
          Sex__pc: data.profile?.genderCode?.toString() ?? "0",
          TransitionSource__pc: user?.user_metadata.transition_source ?? "", // transition_source
          PersonBirthdate: `${data?.profile?.birth?.year}/${data?.profile?.birth?.month}/${data?.profile?.birth?.day}`,
          JobLayer__pc:
            getLabelFromValue(data.workPlaceInfo?.positionCode ?? "") ?? "",
          lbc_office_id__pc: data.workPlaceInfo?.lbcCode ?? "",
          Newsletter1__pc: data.newsletterSubscription?.editorialBooks ?? false,
          Newsletter3__pc: data.newsletterSubscription?.editorialBrain ?? false,
          Newsletter5__pc:
            data.newsletterSubscription?.editorialHansokukaigi ?? false,
          Newsletter6__pc: data.newsletterSubscription?.advertimes ?? false,
          Newsletter7__pc:
            data.newsletterSubscription?.editorialKohokaigi ?? false,
          Newsletter8__pc: data.newsletterSubscription?.contestsAwards ?? false,
          Newsletter9__pc:
            data.newsletterSubscription?.editorialSendenkaigi ?? false,
          Newsletter24__pc: data.newsletterSubscription?.classInfo ?? false,
          Newsletter11__pc:
            data.newsletterSubscription?.digitalMagazine ?? false,
          Newsletter25__pc:
            data.newsletterSubscription?.adPlacementSponsorship ?? false,
          Newsletter18__pc:
            data.newsletterSubscription?.environmentalBusinessOnline ?? false,
          Newsletter21__pc:
            data.newsletterSubscription?.environmentalBusinessOnlineNews ?? false,
          Newsletter10__pc:
            data.newsletterSubscription?.sendenkaigiInfo ?? false,
          Newsletter26__pc:
            data.newsletterSubscription?.jobChangeInfo ?? false,
          SDKG_InterestingThemes__pc: getLabelsFromIds(
            SDKG_InterestingThemes,
            data?.interest?.jobCodes ?? []
          ),
          SDKG_NewDepartment__pc: getLabelsFromIds(
            SDKG_NewDepartment,
            data.workPlaceInfo?.affiliationCodes ?? []
          ),
          SDKG_Occupation__pc: occupationSelect.find(
            (item) => item.value === data?.profile?.occupationCode?.toString()
          )?.label,
          SDKG_EnvironmentalThemes__pc: getLabelsFromIds(
            SDKG_EnvironmentalThemes,
            data?.interest?.environmentBusinessCodes ?? []
          ),
          SDKG_JobChangeInformation__pc: SDKG_JobChangeInformation.find(
            (item) => item.value === data?.interest?.jobChangeCode?.toString()
          )?.label ?? "",
        },
      }));
    }
  }, [data]);

  const handleFetchSurveyId = async () => {
    setStateValue("loader", true);
    try {
      const result = await getSurveyId(survey_web_url_id ?? "");
      if (result) {
        set_survey_id(result.data.surveyId);
      }
    } catch (err) {
      return err;
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleRegistSession = async (result: any) => {
    setStateValue("loader", true);
    try {
      const urlParams = new URLSearchParams(window.location.search);
      if (result.data.statusCode === 200) {
        navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
          state: {
            title: title,
            responseCode: result.data.statusCode,
            noti: "登録完了",
            mess: "お申込みありがとうございます。登録が完了しました。",
            hint: "お申込み登録完了のお知らせメールの詳細をご覧ください。",
          },
        });
      } else if (result.data.statusCode === 202) {
        navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
          state: {
            title: "",
            responseCode: 400,
            noti: "",
            note: "お手続き完了のため、チケットの購入へお進みください。",
            mess: "ご入力ありがとうございます。",
            hint: "登録はまだ完了しておりません。",
            url: result.data.url,
            checkPlans: true,
          },
        });
      } else if (result.data.statusCode === 500) {
        let noti = "登録できませんでした";
        let mess = "";
        let hint = "詳細はイベント情報をご確認ください。";
        if (result.data?.body?.includes("Registration deadline has passed")) {
          mess = "セッションの受付は終了しました。";
        } else if (
          result.data?.body?.includes("Event registration has not started yet")
        ) {
          mess = "イベントの登録期間前です。";
        } else if (
          result.data?.body?.includes("Event registration has closed")
        ) {
          mess = "申込登録に失敗しました。";
          hint =
            "お申込み登録完了のお知らせメールの詳細をご覧ください。\n自動的に前の画面に戻ります。";
        } else {
          noti = "登録できませんでした";
          mess = "申込登録に失敗しました。";
          hint = "詳細はお問い合わせください。";
        }
        navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
          state: {
            title: title,
            responseCode: result.data.statusCode,
            noti,
            mess,
            hint,
          },
        });
      }
    } catch (error) {
      const urlParams = new URLSearchParams(window.location.search);
      navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
        state: {
          title: title,
          responseCode: 500,
          noti: "登録できませんでした",
          mess: "申込登録に失敗しました。",
          hint: "詳細はお問い合わせください。",
        },
      });
    } finally {
      setStateValue("loader", false);
      localStorage.removeItem("mailmagid");
    }
  };

  // 途中離脱を防止するため1つのAPIで処理をする
  const handleUpsertAccountAndSyncSF = async () => {
    try {
      await upsertAccountAndSyncSF(
        {
          SsoID__pc: user?.user_metadata.customUserId,
          Company__pc: user?.user_metadata.workPlaceInfo?.companyName,
          PersonEmail: user?.email
        },
        accountSF ?? {},
        {

          SsoID__c: user?.user_metadata.customUserId.toString(),
          LastName: user?.user_metadata.profile?.fullName?.lastName,
          FirstName: user?.user_metadata.profile?.fullName?.firstName,
          Company__pc: user?.user_metadata.workPlaceInfo?.companyName,
          PersonEmail: user?.email
        },
        accountSF ?? {},
        dataSyncCustomeSf ?? {}
      )
    } catch (error) {
      throw error;
    }
  }

  // const handleActionCrudSF = async () => {
  //   try {
  //     const query = `SELECT Id,Company__pc,LastName,FirstName FROM ACCOUNT WHERE SsoID__pc ='${
  //       user?.user_metadata.customUserId
  //     }' and Company__pc ='${encodeURIComponent(
  //       user?.user_metadata.workPlaceInfo?.companyName
  //     )}' and PersonEmail = '${encodeURIComponent(user?.email)}'`;
  //     try {
  //       const accountSfDetail = await getDetailSF(query);
  //       const id =
  //         accountSfDetail.data.records.length > 0
  //           ? accountSfDetail.data.records?.[0]?.Id
  //           : "";
  //       if (id) {
  //         await updateAccountSF(id, accountSF ?? {});
  //       }
  //     } catch (error) {
  //       return error;
  //     }
  //     const detail = await handleSearchCustomerInfo(
  //       user?.user_metadata.customUserId.toString(),
  //       user?.user_metadata.profile?.fullName?.lastName,
  //       user?.user_metadata.profile?.fullName?.firstName,
  //       user?.user_metadata.workPlaceInfo?.companyName,
  //       user?.email
  //     );
  //     const idAccount = detail?.data?.AccountId ?? "";
  //     if (!idAccount) {
  //       await fetchCreateAccountSF(accountSF ?? {});
  //     }
  //     await handleSyncCustomerInfo(dataSyncCustomeSf ?? {});
  //   } catch (error) {
  //     return error;
  //   }
  // };

  const handlePostResponse = async () => {
    setStateValue("isSaving", true);
    try {
      const result = await getSurveyCollectors(survey_id ?? "");
      const weblinkId = (result.data.data.data as ICollectors[]).find(
        (item) => item.type === "weblink"
      )?.id;
      const urlParams = new URLSearchParams(window.location.search);
      const session_id = urlParams.get("session_id");
      const event_id = urlParams.get("event_id");
      const plans = urlParams.get("plans");

      const originalUser = globalState.user?.user_metadata || {};
      let dataToSave: IUserMetaDataApi = {
        ...data,
        authenticated: 1,
        user_status: 2,
      };
      dataToSave = addTimestamp(originalUser, dataToSave);
      
      // イベントDB, surveyにデータを送信し、auth0のuserのデータを更新する処理と
      // SalesforceのAccount作成・同期処理を並列実行（どちらかが失敗しても両方実行）
      console.log("handle request ------------");
      const [entryResultSettled, upsertResultSettled] = await Promise.allSettled([
        postSurveyAndRegisterSessionAndUpdateUser(
          weblinkId ?? "",
          {
            survey: answerData,
            user: {
              user_metadata: dataToSave
            }
          },
          event_id ?? "",
          session_id ?? "",
          plans ?? ""
        ),
        handleUpsertAccountAndSyncSF()
      ]);

      console.log("handle request end------------");

      // 結果を取得し、失敗した場合はエラーを確認
      const entryResult = entryResultSettled.status === 'fulfilled' 
        ? entryResultSettled.value 
        : null;
      const upsertResult = upsertResultSettled.status === 'fulfilled' 
        ? upsertResultSettled.value 
        : null;

      console.log("entryResult", entryResult);
      console.log("upsertResult", upsertResult);

      if (entryResult === null) {
        throw new Error('Survey registration failed');
      }
      // Salesforceのupsertが失敗した場合（例：proxy APIから空のメールアドレスが返された場合）
      // ユーザーにはエラーを表示せず、申込／アンケート登録は成功しているため処理を継続する。
      // 運用・監視向けに失敗ログのみ出力。
      // ※SDK_TI-1628対応
      if (upsertResult === null) {
        console.warn("Survey entry succeeded but Salesforce upsert failed", upsertResultSettled);
      }

      // const resultMetaData = await fetchUpdateUserMeataData(user_id ?? "", {
      //   ...data,
      //   authenticated: 1,
      //   user_status: 2,
      // });
      // APIの中でauth0のデータ更新を実施しているためリフレッシュが必要
      await refreshAccessToken();
      setGlobalState({
        ...globalState,
        user: {
          ...globalState.user,
          user_metadata: dataToSave
        }
      });
      await handleRegistSession(entryResult);
    } catch (err) {
      const urlParams = new URLSearchParams(window.location.search);
      navigate(`${Routes.SURVEY_ANSWER_FINISH}?${urlParams.toString()}`, {
        state: {
          title: title,
          responseCode: 500,
          noti: "登録できませんでした",
          mess: "申込登録に失敗しました。",
          hint: "詳細はお問い合わせください。",
        },
      });
      return err;
    } finally {
      setStateValue("isSaving", false);
    }
  };

  const renderFieldQuestion = (data: ISurveyQuestion, page_id: string) => {
    if (data.family === "open_ended") {
      return (
        answerData?.pages
          ?.find((page) => page.id === page_id)
          ?.questions?.find((question) => question.id === data.id)?.answers?.[0]
          ?.text ?? ""
      );
    } else {
      const selectedChoices =
        answerData?.pages
          ?.find((page) => page.id === page_id)
          ?.questions?.find((question) => question.id === data.id)
          ?.answers?.map((answer) => answer.choice_id) ?? [];

      let selectedChoiceTexts = "";
      let selectedOtherTexts = "";
      const answers = answerData?.pages
        ?.find((p) => p.id === page_id)
        ?.questions?.find((q) => q.id === data.id)?.answers;
      answers?.forEach((answer) => {
        selectedChoiceTexts =
          data.answers?.choices
            ?.filter((choice) => selectedChoices.includes(choice.id))
            ?.map((choice) => choice.text)
            ?.join("、") ?? "";

        if (answer?.other_id) {
          selectedOtherTexts = answer.text ?? "";
        }
      });

      if(selectedOtherTexts) {
        selectedChoiceTexts = selectedChoiceTexts 
          ? `${selectedChoiceTexts}、${selectedOtherTexts}` 
          : selectedOtherTexts;
      }

      return selectedChoiceTexts || "";
    }
  };

  const renderQuestion = (page: ISurveyPage) => {
    return page?.questions?.map((question) => {
      return (
        <tr key={question.id}>
          <th>
            <div
              dangerouslySetInnerHTML={{
                __html: question.headings?.[0].heading ?? "",
              }}
            />
          </th>
          <td>{renderFieldQuestion(question, page.id ?? "")}</td>
        </tr>
      );
    });
  };

  return (
    <Box className="survey_answer-page mt20">
      {questionData?.pages?.map((page) => {
        return (
          <div className="row mt-5">
            <div className="col-md-12">
              <h2>{page?.title}</h2>
              <div className="row">
                <div className="col-xs-12">
                  <div className="table-normal">
                    <table className="table">
                      <tbody>{renderQuestion(page)}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <div className="register-form_sections">
        <BasicInfo isShow={true} isEdit={false} formData={data} />
        <BasicInterests isEdit={false} userData={data} />
        <WorkPlace isEdit={false} formData={data} />
        <HomePlace isEdit={false} formData={data} />
        <NewsletterSetting data={data} isEdit={false} />
      </div>

      <div className="register-form_submit">
        <Button
          className="register-form_btn js-register-form_btn"
          onClick={() => {
            const urlParams = new URLSearchParams(
              window.location.search
            ).toString();
            navigate(
              `${Routes.SURVEY_ANSWER.replace(
                ":survey_web_url_id",
                survey_web_url_id ?? ""
              )}?${urlParams}`,
              {
                state: {
                  dataEdit: data,
                  questionData: questionData,
                  answerDataEdit: answerData,
                  agreeTerms,
                  agreements,
                },
              }
            );
          }}
        >
          前に戻る
        </Button>
        <Button
          className="register-form_btn js-register-form_btn"
          onClick={handlePostResponse}
        >
          登録する
        </Button>
      </div>
    </Box>
  );
};

export default ConfirmAnswer;
